module.exports = __webpack_public_path__ + "static/result-waiting.3cc22bf9.png";